import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import styles from "./WithdrawalConfirm.module.css";

const WithdrawalConfirm = ({selectBankAccount, withdrawalAmount}) => {
  const {t} = useTranslation();

  return (
    <>
      <h4 className={styles.heading}>{t("withdrawalSteps_3_Confirm")}</h4>

      <div className={styles.infoCard}>
        <div className={styles.dataRow}>
          <p className={styles.dataLabel}>{t("withdrawalSteps_3_Bank")}</p>
          <p className={styles.dataValue}>{selectBankAccount.bankName}</p>
        </div>

        <div className={styles.dataRow}>
          <p className={styles.dataLabel}>{t("withdrawalSteps_3_PhoneNumber")}</p>
          <p className={styles.dataValue}>{selectBankAccount.phone}</p>
        </div>
      </div>

      <div className={styles.amountSection}>
        <p className={styles.amountLabel}>{t("withdrawalSteps_3_YouWillWithdraw")}</p>
        <div className={styles.amountBadge}>
          <span className={styles.amountValue}>
            {new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(withdrawalAmount)}{" "}
            Bs.
          </span>
        </div>
      </div>
    </>
  );
};

WithdrawalConfirm.propTypes = {
  selectBankAccount: PropTypes.object.isRequired,
  withdrawalAmount: PropTypes.number.isRequired,
};

export default WithdrawalConfirm;
